export const selectFunnel = (state, id) => {
  const funnelId = id || state.funnels.currentFunnelId;
  return state.funnels[funnelId];
};
export const selectCurrentFunnelId = (state) => state.funnels.currentFunnelId;
export const selectIsFunnelLoading = (state) => state.funnels.isFunnelLoading;
export const selectProjectId = (state, id) => state.funnels[id]?.projectId;
export const selectIsMigratedC1toC2 = (state) => state.funnels.isMigratedC1toC2;
export const selectIntegrationsSettings = (state) => state.funnels.integrationsSettings;
